import { notEmpty } from './utils/configUtils';

const config = {
  AppSyncUrl: import.meta.env.REACT_APP_CORE_GRAPHQL_API,
  DashboardUrl: import.meta.env.REACT_APP_DASHBOARD_URL,
  Environment: import.meta.env.MODE,
  BaseUrl: import.meta.env.BASE_URL,
  AppVersion: import.meta.env.REACT_APP_APP_VERSION,

  Cognito: {
    Region: import.meta.env.REACT_APP_COGNITO_AWS_REGION,
    UserPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
    ClientId: import.meta.env.REACT_APP_COGNITO_CLIENT_ID,
    IdentityPoolId: import.meta.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    IdpEndpoint: import.meta.env.REACT_APP_COGNITO_IDP_ENDPOINT,
    OauthDomain: import.meta.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
    OauthRedirectSignIn: import.meta.env.REACT_APP_COGNITO_OAUTH_REDIRECT_SIGN_IN,
    CognitoUri: import.meta.env.REACT_APP_COGNITO_URI,
  },
  Datadog: {
    ApplicationId: import.meta.env.REACT_APP_DATADOG_APPLICATION_ID,
    ClientToken: import.meta.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  },
  ContentGeneration: {
    LlamaIndexUrl: import.meta.env.REACT_APP_LLAMA_INDEX_URL,
    StreamingUrl: import.meta.env.REACT_APP_STREAMING_URL,
  },
  Live: {
    Search: {
      MaxResults: 10,
    },
    Audio: {
      Devices: {
        FallbackInterval: 5000,
      },
      activityChange: {
        activate: 2500,
        deactivate: 6000,
      },
      sessionTimeout: {
        body: 60000,
      },
      MinimumSessionDuration: 20000,
    },
    WebSocketUrl: import.meta.env.REACT_APP_LIVE_WEBSOCKET_URL,
    AudioWebsocketUrl: import.meta.env.REACT_APP_AUDIO_WEBSOCKET_URL,
  },
  Auth: {
    Url: import.meta.env.REACT_APP_AUTH_URL,
    Cookies: {
      TokenCookieName: import.meta.env.REACT_APP_TOKEN_COOKIE_NAME,
      OrgOverrideCookieName: import.meta.env.REACT_APP_ORG_OVERRIDE_COOKIE_NAME,
      RoleOverrideCookieName: import.meta.env.REACT_APP_ROLE_OVERRIDE_COOKIE_NAME,
      CookieDomain: import.meta.env.REACT_APP_COOKIE_DOMAIN,
    },
  },
  Urls: {
  },
  PushKey: import.meta.env.REACT_APP_PUSH_KEY,
  NotificationCoolDown: 1000 * 8,
  Translation: {
    CookieName: import.meta.env.REACT_APP_TRANSLATION_COOKIE_NAME,
    CookieDomain: import.meta.env.REACT_APP_COOKIE_DOMAIN,
  },
  Roles: {
    User: 1,
    ExpertUser: 2,
    Admin: 3,
    Owner: 6,
  },
  Unleash: {
    url: import.meta.env.REACT_APP_UNLEASH_URL,
    clientKey: import.meta.env.REACT_APP_UNLEASH_CLIENT_KEY,
    refreshInterval: 15,
    appName: 'live',
    disableMetrics: true,
  },
  AwsRum: {
    AppId: import.meta.env.REACT_APP_AWS_RUM_APP_ID,
    GuestRoleArn: import.meta.env.REACT_APP_AWS_RUM_GUEST_ROLE_ARN,
    Endpoint: import.meta.env.REACT_APP_AWS_RUM_ENDPOINT,
  },
  SupportMail: import.meta.env.REACT_APP_SUPPORT_MAIL,
};

notEmpty('config', config);

export default config;
